import CONSTANTS from "../../../../core/constants";
import { useTranslation } from "react-i18next";
import {
  PaymentStatusCell,
  SlotStatusCellIsPaid,
  SlotStatusCellIsNotPaid,
  SlotStatusCellIsCanceled,
  SlotStatusCellIsNoShow,
  SlotStatusCellIsOrganizerNoShow,
  SlotStatusCellIsNoShowAll,
} from "../styled";

type BookingStatus = keyof typeof CONSTANTS.BOOKING_STATUS;
type SlotBookingStatusProps = {
  status: BookingStatus;
  paid: boolean;
};

export const SlotBookingStatus = ({ status, paid }: SlotBookingStatusProps) => {
  const { t } = useTranslation();
  let statusValue;

  if (status === CONSTANTS.BOOKING_STATUS.CANCELED) {
    statusValue = t("CANCELED");
  } else if (status === CONSTANTS.BOOKING_STATUS.LATE_CANCELED) {
    statusValue = t("LATE_CANCELED");
  } else if (status === CONSTANTS.BOOKING_STATUS.NO_SHOW) {
    statusValue = t("NO_SHOW");
  } else if (status === CONSTANTS.BOOKING_STATUS.ORGANIZER_NO_SHOW) {
    statusValue = t("ORGANIZER_NO_SHOW");
  } else if (status === CONSTANTS.BOOKING_STATUS.NO_SHOW_ALL) {
    statusValue = t("NO_SHOW_ALL");
  } else {
    statusValue = paid ? t("PAID") : t("NOT_PAID");
  }

  // Determine which styled component to use based on status
  let StyledContainer;

  if (
    status === CONSTANTS.BOOKING_STATUS.CANCELED ||
    status === CONSTANTS.BOOKING_STATUS.LATE_CANCELED
  ) {
    StyledContainer = SlotStatusCellIsCanceled;
  } else if (status === CONSTANTS.BOOKING_STATUS.NO_SHOW) {
    StyledContainer = SlotStatusCellIsNoShow;
  } else if (status === CONSTANTS.BOOKING_STATUS.ORGANIZER_NO_SHOW) {
    StyledContainer = SlotStatusCellIsOrganizerNoShow;
  } else if (status === CONSTANTS.BOOKING_STATUS.NO_SHOW_ALL) {
    StyledContainer = SlotStatusCellIsNoShowAll;
  } else if (paid) {
    StyledContainer = SlotStatusCellIsPaid;
  } else {
    StyledContainer = SlotStatusCellIsNotPaid;
  }

  return (
    <PaymentStatusCell as={StyledContainer}>
      <svg height="10" width="10">
        <circle cx="5" cy="5" r="4" />
      </svg>
      {statusValue}
    </PaymentStatusCell>
  );
};
